const autoNgTemplateLoaderTemplate1 = require('./new-members-added.template.html');

'use strict';

import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.membersAdded', [])
        .config(membersAddedConfig);

    membersAddedConfig.$inject = ['$routeProvider'];

    function membersAddedConfig($routeProvider) {
        $routeProvider
            .when('/members-added', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'MembersAddedController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                }
            })
    }
})();
